export default {
	title: '算法模型组',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		modelConfig: '模型配置',
		start: '启动',
		stop: '停止'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		setSuccess: '设置成功',
		configSuccess: '配置成功',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		modelConfigNotExist: '模型配置不存在'
	},
	form: {
		name: '模型组名称',
		code: '模型组编码',
		faultModelName: '故障模型名称',
		sys: '选择特征值',
		mmcodeList: '选择模型',
		placeholder: {
			name: '请输入模型组名称',
			code: '请输入模型组编码'
		}
	},
	table: {
		name: '模型组名称',
		code: '模型组编码',
		mmCodeDescList: '模型名称',
		mmcodeList: '模型编码',
		isEnable: '是否启用'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定',
		modelConfigTitle: '模型配置'
	},
	gridLayout: '格栅布局',
	columns: {
		deviceName: '设备名称',
		sensorName: '测点名称',
		modelGroupName: '模型组名称',
		modelCode: '模型代码',
		modelName: '模型名称',
		isEnabled: '是否启用',
		action: '操作'
	},
	config: {
		selectDevice: '选择设备',
		selectSensor: '选择测点',
		selectAlgorithmGroup: '算法模型组',
		selectModel: '选择模型',
		modelType: '模型类型',
		modelCategory: '模型大类',
		modelCategoryCode: '模型大类编码',
		modelSubcategory: '模型小类',
		modelSubcategoryCode: '模型小类编码',
		modelDescription: '模型描述',
		modelVersion: '模型版本',
		paramConfig: '参数配置',
		paramType: '参数类型',
		paramValue: '参数值',
		paramDesc: '参数描述'
	},
	waveConfig: '加速度波形配置',
	narrowBandWarning: '窄带预警',
	narrowBandWarningDesc: '通过分析窄带能量变化检测设备潜在故障并发出预警 (ZDYJ)',
	broadBandWarning: '宽带预警',
	broadBandWarningDesc: '通过分析宽带能量变化检测设备潜在故障并发出预警 (KDYJ)',
	configSuffix: '配置',
	status: {
		enabled: '启用',
		disabled: '未启用'
	}
}
